import { colors } from "./colors";
import { formatCompact, formatNumber, formatSignedPercent, pctChange } from "./format";

export const METRICS = [
    { key: "clicks", label: "Clicks", formatValue: formatCompact, formatPrecise: formatNumber, formatAxis: formatCompact },
    { key: "impressions", label: "Impressions", formatValue: formatCompact, formatPrecise: formatNumber, formatAxis: formatCompact },
    { key: "ctr", label: "Avg. CTR", formatValue: (v) => `${v.toFixed(2)}%`, formatPrecise: (v) => `${v.toFixed(2)}%`, formatAxis: (v) => `${v.toFixed(1)}%` },
    { key: "position", label: "Avg. position", formatValue: (v) => v.toFixed(1), formatPrecise: (v) => v.toFixed(1), formatAxis: (v) => v.toFixed(0) },
];
export const DEFAULT_METRIC = "clicks";

export const metricOf = (key) => METRICS.find((metric) => metric.key === key) ?? METRICS[0];

export const toneColors = { good: colors.positiveInk, bad: colors.criticalInk, neutral: colors.muted };

/** Position is "lower is better" and changes by its absolute difference. */
export function metricDelta(metric, current, previous) {
    if (metric === "position") {
        const diff = current - previous;
        const flat = Math.abs(diff) < 0.05;
        return {
            text: `${diff > 0 ? "+" : diff < 0 ? "−" : ""}${Math.abs(diff).toFixed(1)}`,
            tone: flat ? "neutral" : diff > 0 ? "bad" : "good",
            direction: flat ? "flat" : diff > 0 ? "up" : "down",
        };
    }
    const pct = pctChange(previous, current);
    const flat = Math.abs(pct) < 0.5;
    return { text: formatSignedPercent(pct), tone: flat ? "neutral" : pct < 0 ? "bad" : "good", direction: flat ? "flat" : pct > 0 ? "up" : "down" };
}
